import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../../../components/theme";

export const useStyles = makeStyles((theme) => ({
  btn: {
    backgroundColor: `${colors.blue} !important`,
    marginTop: "2px !important",
  },
}));
